var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('div',{staticClass:"col-md-12 home-box"},[_c('Breadcrumbs',{attrs:{"title":'Suppliers'}}),_c('SupplierGrid')],1),_c('div',{staticClass:"col-md-12 home-tabs-body"})])
}
var staticRenderFns = []

export { render, staticRenderFns }